import angular from 'angular'

// components
import manageGlobalPitchSegments from './component/manageGlobalPitchSegments.component'

export default angular
  .module('portalApp.manage.globalPitchSegments', [])
  .component('manageGlobalPitchSegments', manageGlobalPitchSegments)
  .name
